import React from 'react';

export class UnsupportedFileError extends Error {
  constructor(file) {
    const message = 'We do not support this file type.';
    super(message);
    this.file = file;
  }
}

export class DropZone extends React.PureComponent {

  constructor(props) {
    super(props);
    this.dropzone     = React.createRef();
    this.onChange     = this.onChange.bind(this);
    this.onDrop       = this.onDrop.bind(this);
    this.toggleActive = this.toggleActive.bind(this);
  }

  componentDidMount() {
    this.dropzone.current.addEventListener('dragenter', this.toggleActive);
    this.dropzone.current.addEventListener('dragleave', this.toggleActive);
    this.dropzone.current.addEventListener('drop', this.onDrop);
    this.dropzone.current.addEventListener('dragover', this.onDragOver);
  }

  componentWillUnmount() {
    this.dropzone.current.removeEventListener('dragenter', this.toggleActive);
    this.dropzone.current.removeEventListener('dragleave', this.toggleActive);
    this.dropzone.current.removeEventListener('drop', this.onDrop);
    this.dropzone.current.removeEventListener('dragover', this.onDragOver);
  }

  toggleActive() {
    this.dropzone.current.classList.toggle('upload-file__dropzone--active');
  }

  onDragOver(event) {
    event.preventDefault();
  }

  onDrop(event) {
    event.preventDefault();
    event.stopPropagation();

    this.dropzone.current.classList.remove('upload-file__dropzone--active');

    const file = event.dataTransfer.files[0];
    this.handleFile(file);
  }

  onChange({ target }) {
    const file = target.files[0];
    this.handleFile(file);
  }

  handleFile(file) {
    if (file && file.name) {
      const extension             = file.name.split('.').pop().toLowerCase();
      const { extensionsAllowed } = this.props;
      const isAllowed             = extensionsAllowed.includes(extension);

      if (isAllowed)
        this.props.onFile(file);
      else
        this.props.onError(new UnsupportedFileError(file));
    }
  }

  render() {
    const { extensionsAllowed } = this.props;
    const accept                = extensionsAllowed.map(extension => `.${extension}`).join(', ');

    return (
      <div className="upload-file">
        <div className="upload-file__dropzone" ref={this.dropzone}>
          {this.props.children}
          <input id="upload-file" type="file" accept={accept} onChange={this.onChange}/>
        </div>
      </div>
    );
  }
}

